export type DumpSyncPhase = 'checking' | 'downloading' | 'ingesting';

const PHASE_LABEL: Record<DumpSyncPhase, string> = {
  checking: 'Vérification…',
  downloading: 'Téléchargement…',
  ingesting: 'Ingestion…',
};

export function dumpSyncPhaseLabel(phase: DumpSyncPhase | null | undefined): string {
  if (!phase) return 'Mise à jour…';
  return PHASE_LABEL[phase] ?? 'Mise à jour…';
}
